// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__epp9S","right":"styles_right__2cUxs"};